import { NextRouter } from "next/router";
import { FC } from "react";
import { ObjectLiteral } from "src/js/constants";
import { CampusOnlineSelector } from "../common/CampusOnlineSelector";
import { Props } from "../propTypes";
import { Helpers } from "./common/helpers";

// eGroups Home Component
/**
 * This component is used to display the eGroups Map and Campus select options for users
 * to search for and sign up for eGroups.
 *
 * The campus values are being pulled from this.props.actions.Main_get_all_campuses().
 * Check this action and the api calls set up within them if you run into any problems.
 */

const getNewUrl = (
    router: NextRouter,
    appendCampusName?: string,
    appendQueryString?: ObjectLiteral
) => {
    const pathNameParts = router.asPath.split("?");
    let pathName = pathNameParts[0];
    // const currentParam = history.location.search;

    if (appendCampusName && pathName.includes(appendCampusName)) return;

    if (router.asPath.endsWith("/")) {
        pathName = router.asPath.slice(0, -1);
    }

    router.push({
        pathname: pathName + "/" + (appendCampusName ?? ""),
        query: {
            ...Helpers.getQueryParamsWithoutCampus(router.query),
            ...appendQueryString,
        },
    });
};

const EgroupCampusSelector: FC<
    Props & { setShowCampusSelector: Function; eGroupBaseUrl: string }
> = (props) => (
    <div className="EgroupCampusSelector extra-high-minus-menu flex flex-justify-center flex-align-center">
        <div className="flex flex-column min-ht-100vh">
            <CampusOnlineSelector
                onlineLink="#"
                campusLink="#"
                onlineLinkExternal={false}
                onlineLinkID={`cc-egroups${
                    props.eGroups.eGroupHomeData.name
                        ? `-${props.eGroups.eGroupHomeData.name.toLowerCase()}`
                        : ""
                }-efam`}
                campusLinkID={`cc-egroups${
                    props.eGroups.eGroupHomeData.name
                        ? `-${props.eGroups.eGroupHomeData.name.toLowerCase()}`
                        : ""
                }-campus`}
                campusLinkExternal={false}
                onlineOnCardClick={() => {
                    getNewUrl(props.router, "elevation-online");
                }}
                campusOnCardClick={() => {
                    props.setShowCampusSelector(false, () => {
                        getNewUrl(props.router, undefined, {
                            campusSelector: "1",
                        });
                    });
                }}
            />
        </div>
    </div>
);

export default EgroupCampusSelector;
